<template>
  <div class="flex items-center gap-3" data-testid="header-free-uploads-banner">
    <span class="hidden sm:inline-flex">
      <Button v-if="isPricingUpdateEnabled" type="solid" variant="orange" data-testid="viewer-header-upgrade-button" @click.prevent="openLimitsModal">
        Upgrade
      </Button>
      <Button
        v-else
        type="solid"
        variant="orange"
        href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer"
        data-testid="viewer-header-upgrade-button"
      >
        Upgrade
      </Button>
    </span>
    <button
      v-if="isPricingUpdateEnabled"
      type="button"
      class="flex sm:hidden flex-col h-9 mr-2 px-2 py-0.5 border border-transparent rounded-10 outline-none focus-visible:ring select-none text-white bg-gradient-to-tr from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 focus-visible:ring-red-500/50"
      @click="openLimitsModal"
    >
      <span class="text-sm font-bold">Upgrade</span>
      <span v-if="showUploadBar" data-testid="hard-limit-counter-mobile" class="-mt-1 text-xs">LIMIT: {{ uploadsUsed }}/{{ uploadsLimit }}</span>
    </button>
    <a
      v-else
      href="/plans?utm_campaign=upgrade&utm_medium=button&utm_source=viewer"
      class="flex sm:hidden flex-col h-9 mr-2 px-2 py-0.5 border border-transparent rounded-10 outline-none focus-visible:ring select-none text-white bg-gradient-to-tr from-orange-500 to-red-500 hover:from-orange-600 hover:to-red-600 focus-visible:ring-red-500/50"
    >
      <span class="text-sm font-bold">Upgrade</span>
      <span data-testid="hard-limit-counter-mobile" class="-mt-1 text-xs">LIMIT: {{ legacyItemCount }}/{{ legacyDropLimit }}</span>
    </a>
    <div v-if="isPricingUpdateEnabled && showUploadBar" class="hidden sm:flex flex-col text-xs text-slate-400 dark:text-zinc-600">
      <div class="uppercase tracking-wide">
        <span>Free limit:</span>
        <span data-testid="hard-limit-counter" class="font-semibold text-amber-600"> {{ uploadsUsed }}/{{ uploadsLimit }}</span>
      </div>
      <div class="h-1 mt-1 w-28 rounded-full bg-slate-200 dark:bg-zinc-800 relative">
        <div class="absolute top-0 left-0 h-full rounded-full bg-amber-600" :style="{ width: uploadsPercent + '%' }"></div>
      </div>
    </div>
    <div v-else class="hidden sm:block text-sm text-slate-400 dark:text-zinc-600">
      <div class="uppercase block md:inline">
        <span>Free limit:</span>
      </div>
      <span data-testid="hard-limit-counter" class="font-semibold text-amber-600"> {{ legacyItemCount }}/{{ legacyDropLimit }}</span>
      <div class="h-0.5 mt-1 rounded bg-slate-200 dark:bg-zinc-800 relative">
        <div class="absolute top-0 left-0 h-full bg-amber-600" :style="{ width: legacyItemCapacityPercent + '%' }"></div>
      </div>
    </div>
  </div>
</template>
<script setup lang="ts">
import { computed } from 'vue';
import { storeToRefs } from 'pinia';
import { useEntitlementsStore } from '@/store/useEntitlementsStore';
import { useUserStore } from '@/store/useUserStore';
import { Button } from '@/storybook/button';
import { useLimits } from '@/composables/useLimits';

const { openLimitsModal, isPricingUpdateEnabled, planTier } = useLimits();

const showUploadBar = computed(() => planTier.value === 'free');

const userStore = useUserStore();
const { itemCount: legacyItemCount, itemCapacityPercent: legacyItemCapacityPercent, dropLimit: legacyDropLimit } = storeToRefs(userStore);

const { limits, quotas } = storeToRefs(useEntitlementsStore());

const uploadsLimit = computed(() => limits.value.viewableItemsLimit ?? 0);
const uploadsUsed = computed(() => quotas.value.viewableItems?.used ?? 0);
const uploadsPercent = computed(() => {
  const limit = uploadsLimit.value;
  if (!limit) {
    return 0;
  }
  return Math.min(Math.round((uploadsUsed.value / limit) * 100), 100);
});
</script>
